ja:
  acceptInvite:
    continueWithFacebookText: Facebookでログイン
    firstNameErrorRequired: 名前を記入してください。
    firstNameLabel: 名
    firstNamePlaceholder: 名
    helloFNameText: 'こんにちは {{fName}}様'
    lastNameErrorRequired: 苗字を記入してください。
    lastNameLabel: 姓
    lastNamePlaceholder: 姓
    otpLabel: 2FAを有効にする。
    otpSecretErrorRequired: 記入してください。
    otpSecretLabel: QRコードを認証アプリでスキャンしてください。
    otpSecretPlaceholder: 認証アプリで表示されるコード。
    passwordConfirmationErrorRequired: パスワードを入力してください。
    passwordConfirmationLabel: パスワードの確認
    passwordConfirmationPlaceholder: パスワードの再入力
    passwordError: 'パスワード {{passwordError}}'
    passwordErrorRequired: パスワードを入力してください。
    passwordLabel: パスワード
    passwordPlaceholder: パスワードを入力してください。
    passwordShouldBeStrong: パスワードは８文字以上、大文字小文字を含む、数字と記号を含めてください
    passwordShouldMatchError: 同じパスワードを入力してください
    provideYourDetailsText: '情報を入力してください:'
    signInWithFacebookBtn: Facebookでログイン
    signUpBtn: 新規登録する
    welcomeToSRText: Shuttlerockへようこそ！
  accountSettings:
    accountSettingsUpdated: アカウント設定を更新しました。
    clientNameLabel: クライアント名
    clientNamePlaceholder: クライアント名
    edit: 編集
    emailLabel: メールアドレス
    emailPlaceholder: メールアドレス
    emailemail: 有効なメールアドレスを記入ください。
    emailrequired: こちらの項目は必須です。
    firstNameLabel: 名前
    firstNamePlaceholder: 名
    firstNamerequired: この項目は必須です。
    lastNameLabel: 姓
    lastNamePlaceholder: 姓
    lastNamerequired: この項目は必須です。
    loading: 読み込み中...
    notificationValidatedBody: '確認のメールが{{email }}に再送されました。'
    notificationValidatedHeader: メールが再送されました。
    notificationWarningBody: 下記のアドレスにメールを送信しましたので、ご確認の上、アカウントを有効化してください。メールが届きませんでしたか？<1>Resend Confirmation</1>
    notificationWarningHeader: メールアカウントをご確認ください。
    passwordLabel: パスワード
    reset: 再設定
    submit: 変更内容を保存
    title: アカウント設定
  accountType:
    subscription: シャトルロック　アンリミテッド（subscription）
    unrestricted: 無制限のご注文
  advertListPage:
    addAdvert: パックを追加
    modalDeleteCancelButton: キャンセル
    modalDeleteConfirmationButton: パックを削除
    modalDeleteConfirmationText: このパックを削除してもよろしいですか？ <br /> 一度広告パックを削除すると、元に戻すことはできません。
    modalDeleteConfirmationTitle: '削除: パック {{name}}'
    successDeleteContent: 広告が正常に削除されました。
    successDeleteHeader: 広告削除済み
  conceptPanel:
    submitToProduction: 制作に提出する
    designersLabel: デザイナー
    designersPlaceholder: 'デザイナーを選択 {{artDirector}}'
    designersUpdated: デザイナー更新
    productionMetadataErrorUpdate: 制作メタデータを更新できませんでした。ページを再読み込みして、もう一度お試しください。
    no: いいえ
    notes: ノート
    notesUpdated: ノートが更新されました。
    untitledConceptName: '無題のコンセプト'
    primaryLanguageLabel: 主要言語
    primaryLanguageErrorLoading: 言語の読み込みに失敗しました。もう一度お試しください
    primaryLanguageErrorRequired: 主要言語は必須です
    primaryLanguageErrorUpdate: 主要言語を更新できませんでした。もう一度お試しください
    marketShortLabel: 市場
    targetAudience: 'ターゲットオーディエンス:'
    targetAudienceInterests: '興味関心:'
    targetAudienceGenderAll: '全ての性別'
    targetAudienceGenderFemale: '女性'
    targetAudienceGenderMale: '男性'
    targetAudienceLifestyle: 'ライフスタイル:'
    targetAudienceLocation: '所在地:'
    yes: はい
    localisation:
      localisationInstructions: ローカライゼーション指示
      localisationAssets: ローカライゼーションアセット
      noInstructionsProvided: (指示が提供されていません)
      primaryTargetMarket: 主要ターゲット市場（ソースロケール）
      additionalTargetMarkets: 追加ターゲット市場
      localiseCopy: コピーのローカライズ
      localiseAsset: アセットのローカライズ
      localiseVoiceover: ボイスオーバーのローカライズ
      additionalInstructions: 追加指示
      translationStringsSheetURL: 翻訳文字列シートURL
    deliverableTable:
      baseDeliverables: '追加フォーマット 納品物 ({{count}}/{{total}})'
      copyFilenameError: 'ファイル名をクリップボードにコピーできませんでした'
      copyFilenameSuccess: 'ファイル名をクリップボードにコピーしました！'
      details: 詳細
      dimension: サイズ
      duration: 秒数カテゴリー
      expressProject: エクスプレスプロジェクト
      filename: ファイル名
      format: フォーマット
      hero: ヒーロー
      variations: バリエーション
      variation: 'バリエーション {{index}} - {{name}}'
      heroDeliverables: 'ヒーロー動画 納品物 ({{count}}/{{total}})'
      viewLink: 表示
    workflow:
      error:
        update: サブステージを更新できませんでした
        validation: バリデーションエラーのためステージを更新できませんでした
    ugcInformation:
      sectionLabel: UGCアイデアとクリエイターブリーフ
      alert:
        title: 参考用のみ
        content: このコンテンツはUGCクリエイターとアイデアチームのためにキュレーションされており、ヒーロー制作の追加コンテキストのみを提供します。
      brandDetails:
        brandDetailsLabel: ブランド詳細
        productPositioningLabel: 'ブランド/製品ポジショニング:'
        socialChannelsLabel: 'ソーシャルチャネル:'
      conceptDirectionLabel: UGCコンセプトの方向性
      approachLabel: アプローチ
      deliverableLabel: UGC納品物
      creatorPreferences:
        preferencesLabel: クリエイター設定
        ageLabel: '年齢:'
        genderLabel: '性別:'
        ethnicityLabel: '民族:'
        locationLabel: '所在地:'
        hobbiesLabel: '興味と趣味:'
        extraRequirementsLabel: '追加要件:'
      procurementLabel: 商品調達
      voiceOverInstructionsLabel: スクリプトまたはボイスオーバー指示
      languageLabel: 言語
      additionalInstructionsLabel: クリエイターへの追加指示
      hookLabel: フック
      doAndDontLabel: すべきこと・すべきでないこと
      legalRequirementsLabel: 法的要件
      sellingPointsLabel: 独自のセールスポイント
    ugcBrandAssetsLabel: UGCブランド素材
    ugcReferenceAssetsLabel: UGCリファレンス素材
    ugcDeliverablesLabel: UGC納品物
  advertsSummary:
    duration: '({{length}} 秒)'
    edit: 編集
    noVariations: バリエーションなし
    orderSummary: ご注文の概要 - フルオーダー
    variations_one: '{{count}} バリエーション'
    variations_other: '{{count}} バリエーション'
    wouldYouLike: 他の広告を追加しますか？
  aiModels:
    label: 好ましい AI モデル
    category:
      IMAGE: 画像
      VIDEO: 動画
      AUDIO: 音声
      MUSIC: 音楽
      VOICE: ボイスオーバー
    model:
      all: あらゆるAIモデル
      none: なし
      default: 既定
  alert:
    goBack: 戻る
    guestThanksReturnToSignInBtn: サインインに戻る
    notFoundPageNotFoundText: お探しのページが見つかりません。
    notFoundSupportEmailText: 'お探しのページが見つかりません。{{supportEmail}}までご連絡ください。'
    notFoundTitle: ページが見つかりません
    oopsOhNoTitle: エラーがおきました。
    oopsSomethingWentWrongText: 申し訳ありません、現在何らかの問題が発生しています。
    oopsTryAgainLaterText: 後でもう一度試してみてください。この問題が数時間で解決しない場合は、サポートチームに連絡してください。
    orderThanksHomeButton: ホーム
    orderThanksText: ご注文が送信され、まもなく確認のメールが届きます。
    orderThanksTitle: ご注文ありがとうございます。
    orderThanksTrackYourOrderButton: ご注文を追跡する。
    v1BriefNotExistsText: 'プロジェクトの詳細はShuttlerock Cloudに存在しません。必要に応じて、クリエイティブスペシャリストにブリーフのコピーをお問い合わせください。'
  assetPicker:
    audio: 音声ファイル
    brand: ブランドガイドラインのファイル
    browseFiles: ファイルを選択
    compressed: Zipファイル
    dropFiles: ここにファイルをドロップ
    font: フォントファイル
    logo: ロゴファイル
    music: 音声ファイル
    placeholder: ここにファイルをドロップ
    stills: 画像
    uploaderMaxFiles: '申し訳ございません。この商品のアセットアップロードの上限は{{count}}です'
    uppyError: アップロードしようとしたファイルに問題が発生しました。
    video: 動画ファイル
  assetUploader:
    notesPlaceholder: このファイルについてのノートを追加する。
    preferredFileTypes: 優先されるファイルの種類。
  assetsForm:
    assetUploadError: ファイルを読み込む際に問題が発生しました。再度お試しいただくか、サポートにお問い合わせください。
    brandFontSupportedTypes: 'サポートされているファイルタイプ: .otf、.ttf、.fnt、.ttc、および .woff'
    brandFontTitle: フォント
    brandGuidelinesSupportedTypes: 'サポートされているファイルタイプ: .png、.jpg、.jpeg、.psd、.ai、.eps、.svg、および .pdf'
    brandGuidelinesTitle: ブランドガイドライン
    brandLogoNOTSupportedTypes: .tif と .tiff はサポートされていません。
    brandLogoSupportedTypes: サポートされているファイルタイプ：.png、.jpg、.jpeg、.psd、.ai、.eps、.tif、.tiff、および .svg
    brandLogoTitle: ロゴ
    brandMusicInformation: 音楽が提供されていない場合、Shuttlerockは適切な音楽を選択して使用します。
    brandMusicSupportedTypes: 'サポートされているファイルタイプ: .wav、.mp3、.aiff、.m4a、.flac、.alac、.aac、および .wma'
    brandMusicTitle: 音楽ファイル
    cancelBtn: 戻る
    fontLabel: フォント
    guidelinesLabel: ガイドライン
    instructions: ロゴ、フォントファイル、ブランドガイドラインをアップロードしてください。
    logoLabel: ロゴ
    minimizeBtnLabel: 最小化
    musicLabel: 音楽
    optional: 任意
    preferred: 優先
    requiredInformation: '* 必須'
    sectionInstructions: ブランド素材をアップロード
    submitBtn: 次
    supportedFileTypes: サポートされているファイルの種類：
    title: ブランド素材
    viewAllBtnLabel: 全てを表示
    whatToUpload: アップロードする内容
  authForm:
    continueWithFacebook: Facebookで続ける。
    continueWithGoogle: Googleで続ける。
    emailErrorEmail: これは、メールである必要があります。
    emailErrorRequired: この項目は必須です。
    emailLabel: メールアドレス
    emailPlaceholder: メールアドレス
    facebookAuthorizationFailed: Facebookの認証が失敗またはキャンセルされました。
    forgotPasswordLink: パスワードを忘れた場合
    getStarted: 始めましょう
    googleAuthorizationFailed: Googleの認証が失敗またはキャンセルされました。
    heading: サインイン
    notAUser: 'まだアカウントをお持ちではありませんか？ '
    otpAttemptLabel: ワンタイムパスワード
    otpAttemptPlaceholder: 認証機関からのOTPを入力してください。
    otpLabel: 2FA
    passwordErrorRequired: この項目は必須です。
    passwordLabel: パスワード
    passwordPlaceholder: パスワード
    passwordResetSuccessMessage: パスワードがリセットされましたので、新しいパスワードでログインしてください。
    rememberMeLabel: ログイン情報を記憶する
    signInBtn: ログイン
    signInError: 問題が発生しました。後でもう一度お試しいただくか、サポートにお問い合わせください。
    signInWithEmail: メールでサインインする。
    signInWithFacebookBtn: Facebookでログイン
  brandAssets:
    brandNotesLabel: ブランドのクリエイティブ制作時に気をつけていただきたいポイントは？
    brandNotesPlaceholder: ここに入力してください
    formDescription: ロゴ、フォント、ブランドガイドラインをアップロードしてください。
    formTitle: ブランド素材
    next: 次
    reviewMyOrder: ご注文内容を確認する
    save: 保存して終了
    selectedLogosErrorRequired: この項目は必須です。
    selectedLogosLabel: ブランドロゴをアップロードしてください。
    selectedOthersHelp: 提供されていない場合、Shuttlerockは適切な音声やフォントを選択して使用します。
    selectedOthersLabel: フォント、ブランドガイドラインと音源ファイルをアップロードしてください。
  brandAssetsManagement:
    title: '{{name}}のブランド素材'
  briefTracker:
    brandAssets: ブランド素材
    campaignDetails: キャンペーン詳細
    summary: 概要
  clientForm:
    accountTypeErrorRequired: アカウントタイプを選択してください
    accountTypeLabel: このクライアントの注文はどのように管理されるのでしょうか？
    accountTypeDescriptionUnrestricted: 注：このアカウントタイプの場合、ご注文の制限はありません。
    cancelBtn: キャンセル
    cannotBeEditedWarning: 注意 - 承認した後に修正はできません
    clientCreated: クライアントを作成しました。
    clientPartnersErrorRequired: この項目は必須です。
    clientPartnersLabel: クライアントパートナー
    clientPartnersPlaceholder: クライアントパートナーを選択
    creativeSpecialistsErrorRequired: この項目は必須です。
    creativeSpecialistsLabel: クリエイティブスペシャリスト
    creativeSpecialistsPlaceholder: クリエイティブスペシャリストを選択
    descriptionLabel: クライアント説明
    descriptionPlaceholder: クライアントの説明を短く記載してください
    facebookUrlLabel: Facebook
    facebookUrlPlaceholder: Facebookのリンクを入力してください
    hubspotIdErrorRequired: この項目は必須です。
    hubspotIdLabel: HubspotのクライアントID
    hubspotIdPlaceholder: HubspotのクライアントIDを入力してください
    instagramUrlLabel: Instagram
    instagramUrlPlaceholder: Instagramのリンクを入力してください
    loggedOutDownloadingLabel: ログインしていないユーザーがクリエイティブをダウンロードすることを許可
    nameCannotBeEditedWarning: 注意 - 承認した後に修正はできません
    nameErrorRequired: この項目は必須です。
    nameLabel: クライアント名
    namePlaceholder: クライアント名を入力してください
    'no': いいえ
    otherUrlLabel: その他
    otherUrlPlaceholder: '例： https://www.example.com/'
    pinterestUrlLabel: Pinterest
    pinterestUrlPlaceholder: Pinterestのリンクを入力してください
    platformsErrorRequired: この項目は必須です。
    platformsLabel: カスタムオーダーで利用可能なプラットフォームを選択してください
    platformsPlaceholder: プラットフォームを選択
    preApprovalDownloadingLabel: 承認前にクライアントがクリエイティブをダウンロードすることを許可
    regionErrorRequired: この項目は必須です。
    regionLabel: 地域
    regionPlaceholder: 地域を選択してください
    sectionClientDetails: クライアント情報
    sectionDownloads: ダウンロード
    sectionOrdering: 受注
    sectionShuttlerockDetails: Shuttlerock情報
    submitBtn: 承認
    successUpdateBody: '{{clientName}}が正常に更新されました。'
    successUpdateHeader: クライアントの更新
    tiktokUrlLabel: TikTok
    tiktokUrlPlaceholder: TikTokのリンクを入力してください
    twitterUrlLabel: Twitter
    twitterUrlPlaceholder: Twitterのリンクを入力してください
    verticalLabel: 業種
    verticalPlaceholder: 下記より選択してください
    websiteUrlLabel: ウェブサイト
    websiteUrlPlaceholder: ウェブサイトリンクを入力してください
    'yes': はい
    youtubeUrlLabel: YouTube
    youtubeUrlPlaceholder: YouTubeのリンクを入力してください
  clientList:
    actionBtnAriaLabel: クライアントアクションメニューを開く
    actionsLabel: アクション
    assetsBtn: ブランド素材
    clientCopiedContent: '{{clientName}}のクライアントIDがクリップボードに追加されました'
    clientCopiedTitle: クライアントIDがコピーされました！
    clientNameLabel: クライアント名
    clientSearchLabel: 検索
    copyClientId: クライアントIDをコピー
    editBtn: 編集
    emptyTableMessage: 表示できるクライアントがありません。新しく登録する場合は「新しいクライアント登録」を選択してください。
    header: '{{name}} クライアント'
    manageUsersBtn: ユーザーの管理
    newClientBtn: 新しいクライアント登録
    ownerEmailLabel: 代表者メールアドレス
    salesTerritoriesPlaceholder: 全ての営業地域
    salesTerritoryLabel: 営業地域
  colorpicker:
    close: 閉じる
    notesPlaceholder: この色についてのノートを追加する
  common:
    loadMoreBtn: もっと表示
  confirmOrderErrorModal:
    description: 制作ブリーフの提出準備が整った際にお戻りください。
    return: 制作ブリーフに戻る。
  confirmOrderModal:
    approveBriefToastMessage: ブリーフが承認され、Google Driveのファイルが準備されています。この案件は後に制作中に移動します。
  datepicker:
    applyCustomDate: カスタム日付を適用する
    phrases:
      close: 閉じる
      datepickerEndDateLabel: '終了日:'
      datepickerEndDatePlaceholder: 選択
      datepickerStartDateLabel: '日付をリセット:'
      datepickerStartDatePlaceholder: 選び出す
      endDateAriaLabel: 終了日
      endDatePlaceholder: 終了日
      resetDates: 日付をリセット
      startDateAriaLabel: 日付をリセット
      startDatePlaceholder: 日付をリセット
  deliverableState:
    approved: 承認済み
    expired: 期限切れ
    internally_rejected: 社内で却下されました。
    pending_delivery: 納品保留中
    client_review: クライアントレビュー保留中
    internal_review: インターナルレビュー保留中
    rejected: 却下
  dimensionInput:
    addBtnLabel: 追加
    dimensionAlreadyExistsError: この比率はすでに存在します。
    heightLabel: H
    heightLessThanError: '縦幅は{{max}}以下'
    heightMoreThanError: '縦幅は{{min}}以上'
    heightRequiredError: 縦幅が必要です。
    information: サイズはピクセル数で記載ください。
    widthHeightLessThanError: '横幅・縦幅は{{max}}以下'
    widthHeightMoreThanError: '横幅・縦幅は{{min}}以上'
    widthHeightRequiredError: 横幅・縦幅が必要です。
    widthLabel: W
    widthLessThanError: '横幅は{{max}}以下'
    widthMoreThanError: '横幅は{{min}}以上'
    widthRequiredError: 横幅が必要です。
  editCopyModal:
    callToAction: コールトゥアクション
    ctaDescription: ユーザーを特定のアクションに誘導します
    mockupDescription: これはプロジェクトのモックアップではなく、広告コピーの構成方法を視覚的に示すための画像です。
    mockupTitle: 動画モックアップの例
    primaryCopy: 第1テキストは伝えたいコアメッセージです
    saveAndClose: 保存して閉じる
    saveAndOpenNext: 保存して次のバリエーションを開く
    secondaryCopy: 第2テキストは製品のメリットを強調します
    tertiaryCopy: 第3テキストは第1テキストと第2テキストをサポートします。
  emailConfirmationResent:
    body: 確認メールを再送信しましたので、ご確認の上、アカウントを有効にしてください。メールが届きませんでしたか？<1>Account Settings</1>でメールアドレスを確認してください。
    heading: メールが再送信されました。
  emailConfirmed:
    body: 'メール{{email}}をご確認いただきありがとうございます。'
    heading: メール確認済み
  error:
    errorLabel: エラー
    gqlError: 申し訳ありません、何か問題が発生しました。後でもう一度お試しください。
    invalidUrl: 有効なURLである必要があります。
    networkIssue: 申し訳ありません、ネットワークに問題が発生しました。後でもう一度お試しください。
    okButtonText: 承認
    oopsIntroText: おっと! エラーが発生しました!
    orderNotFoundToastMessage: ライブチャットでShuttlerock Cloudスペシャリストにご相談いただくか、<1> help@shuttlerock.com </1>までメールでお問い合わせください
    orderNotFoundToastTitle: このブリーフにアクセスできません
  exportSpinner:
    close: 閉じる
    exportCompleted: エクスポート完了
    exportSpinnerText: '{{totalCount}}中{{successCount}}の制作物の書き出しに成功しました。'
    facebookGenericErrorMessage: 'エクスポートに失敗しました。問題が続く場合は、<2>サポートにお問い合わせください</2>。'
  facebookDetails:
    checkYourDetails: お客様の詳細が正しいことを確認してください。
    content: Facebookのアカウントより情報を引っ張ってきました。変更する内容がある場合は下記で、または後ほどアカウント設定で編集してください。
    edit: 編集
    emailLabel: メール
    emailPlaceholder: メール
    emailemail: これは有効なメールである必要があります。
    emailrequired: この項目は必須です。
    firstNameLabel: 名
    firstNamePlaceholder: 名
    firstNamerequired: この項目は必須です。
    lastNameLabel: 姓
    lastNamePlaceholder: 姓
    lastNamerequired: この項目は必須です。
    loading: 送信中...
    noEmailPermission: Shuttlerockとメールを共有しないことを選択されています。重要なプロジェクトの更新を送信できるようにメールを追加し、アカウント情報が正しいことを確認してください。
    submit: 送信して続行
    title: お客様の詳細：
    welcomeToSRText: Shuttlerockへようこそ！
  fileType:
    audio: 音声
    brand: ブランド
    compressed: Zip
    font: フォント
    logo: ロゴ
    stills: 画像
    video: 動画
    brand_logo: ブランドロゴ
    reference: リファレンス
    text_field: サポートファイル
  footer:
    privacy: プライバシー
    support: お問い合わせ
    supportRequest: 'お問い合わせ依頼 {{name}}'
    terms: 利用規約
  general:
    cancel: キャンセル
    confirm: 確認
    create: 作成
    delete: 削除
    dimension: '{{width}}W : {{height}}H'
    directDownloadSuccess: ダウンロードを開始しました。
    disclaimer: 'このまま続けると、Shuttlerockの<1>プライバシーポリシー</1>、<3>利用規約</3>に同意したことになります。'
    download: ダウンロード
    edit: 編集
    error: エラー
    googleDrive: Google Drive
    hero: ヒーロー
    link: リンク
    loading: 読み込み中
    next: 次
    'no': いいえ
    onBeforeUnloadMessage: 変更した内容は保存されないことがあります。
    pleaseEnterBetween: '{{min}}から{{max}}の間の値を入力してください'
    pleaseEnterWholeNumber: 整数を入力してください
    previous: 前へ
    review: レビュー
    save: 保存
    saveAndExit: 保存して終了
    search: 検索
    select: 選択
    success: 成功！
    update: 更新
    view: 表示
    viewAll: '全て表示 {{name}}'
    viewFullList: '全リストを表示 ({{ number }})'
    viewLess: 少なく表示
    'yes': はい
  header:
    briefSummaryHeaderText: ブリーフ概要
    demoSiteWarning: サンプル - この発注は制作されません。
    editClientHeaderText: クライアントの編集
    newClientHeaderText: クライアントを追加する
    newOrderHeaderText: 発注する。
    orderDeliverableUploadHeaderText: 納品物をアップロードする。
    orderFormHeaderText: 注文フォーム
    orderInternalDeliverableListHeaderText: クリエイティブを送信
    signInLink: ログイン
    signInText: ユーザーの方
    userInviteHeaderText: ユーザーを招待する
    usersListHeaderText: '{{name}} ユーザー'
  inputElement:
    inputPlaceholder: ここに答えを入力してください...
  instantAnswer:
    checkboxValuesNumber: '選択するオプションは{{minSelected}} 以上で {{maxSelected}}以下でお願いします。'
    requiredFieldText: この項目は必須です。
  formatLengths:
    durationSelectOptionsTitle: 再生時間
  lightbox:
    aviNotSupported: 申し訳ございませんが、このブラウザではAVIファイルを再生できません。
    dimensionsLabel: 'サイズ:'
    downloadAssets: アセットをダウンロード
    durationLabel: '再生時間:'
    fileSizeLabel: 'ファイルサイズ:'
    fileTypeLabel: 'ファイルタイプ:'
    resolutionLabel: '解像度:'
    staticDuration: 静止画
  mainMenu:
    accountSettings: アカウント設定
    signOut: サインアウト
    support: サポート
  objectives:
    brand_awareness: ブランド認知
    consideration: 検討
    direct_response: ダイレクトレスポンス
    full_funnel: フルファネル
    unknown: 不明
  orderAdvertAnswers:
    assetsErrorRequired: こちらの広告パックのための素材を最低１つ選択してください。
    assetsLabel: この広告で活用したい素材を選択してください。
    assetsTooltip: 'お勧めの素材数：<br/><strong>静止画:</strong> 画像1枚<br/><strong>6秒動画:</strong> 動画1本 or 静止画1枚<br/><strong>15秒動画:</strong> 動画1本 AND/OR 静止画5枚<br/><strong>30秒動画:</strong> 動画1本 AND/OR 静止画15枚<br/>'
    autoSaveInfo: 自動的に進捗状況が保存されます
    clickToAdd: プレビューボックス内に素材を含むかを選択してください
    conceptVariationTitle: '広告内容：{{advertName}} -コンセプト {{ variationNumber }}'
    formDescription: こちらの広告を制作するための素材の選定とコピーを選択してください。
    formTitle: '広告の詳細: {{name}}'
    languagesErrorRequired: これは必須の質問です
    languagesLabel: '翻訳が必要な言語を選択してください({{numLanguages}} 必要)。'
    languagesPlaceholder: 言語
    languagesVariationInformation: 後日、翻訳したコピーの提出を求められます。
    noResponseText: なし
    noVariations: バリエーションなし
    numOfLanguagesError: '{{numLanguagesToSelect}} つの言語を選択する必要があります。'
    objectiveErrorRequired: これは必須の質問です
    objectiveLabel: キャンペーン目標を最もよく説明するものはどれですか？
    objectiveShortLabel: キャンペーン目標
    overview: 動画のスペックの概要
    productOrServiceShortLabel: 商品 / サービス
    required: この質問への回答は必須です
    submit: 送信
    submitting: 読み込み中...
    useRootAdvertAnswersFalse: 広告コピーの変更
    useRootAdvertAnswersLabel: コピーは同じにするか、変更することが可能です。
    useRootAdvertAnswersTrue: '*広告コピーを同じにする'
  orderAdvertList:
    accessDeniedMsg: 一度提出すると内容が編集できなくなります。 変更が必要な場合はサポートへお問い合わせください。
    heading: ご注文の詳細
    orderSaved: ご注文が保存されました
    modalDeleteCancelButton: キャンセル
    modalDeleteConfirmationButton: コンセプトを削除
    reviewMessage: 注文の確定をする前に内容の再確認をお願いします。一度確定した場合、修正はできません。
    save: 保存して終了
    startBrief: ブリーフを始める
    subHeading: ご注文を送信する前に詳細を確認してください。
    totalOrderDeliverables: 注文の納品物。
  orderAdvertNew:
    orderAdvertFormHeaderText: カスタムオーダー
    platformRequired: 少なくとも1つのプラットフォームを選択してください
    reviewBtn: 注文を確認する
  orderAdvertNewSummary:
    advertSummaryTitle: 広告概要
  orderAnswersEdit:
    assetsDescription: このクリエイティブに活用したい画像、動画、音源などの素材をアップロードください。<br/>キャンペーン別でアップロードしたい場合は、次のページでもアップロード可能です。
    assetsErrorRequired: 最低1つの素材ファイルをアップロードください。
    assetsHelp: 広告パックをブリーフする際にこちらから素材を選んでいただきます。
    assetsLabel: キャンペーン素材
    autoSaveInfo: |
      進行は自動保存されます。
    baseLanguageErrorRequired: この項目は必須です。
    baseLanguageLabel: ベースの動画の言語を選択してください。
    baseLanguagePlaceholder: 言語を選択してください
    campaignQuestionsTitle: キャンペーンに関するご質問
    formDescription: デザイナーが効果的な広告を作るために、キャンペーンの目的を記入してください。
    formTitle: キャンペーンの詳細
    languageTooltip: 最初にベース動画を、バリエーションや翻訳動画制作する前に、ご納品いたします。
    required: この質問への回答は必須です
  orderAssetEdit:
    submitBtn: 保存して続行
  orderBriefAnswerList:
    label:
      assetSources: 素材リソース
    assetSources:
      supplementAssets: '提供された素材を次で補完:'
      stockAssets: ストックアセット
      website: 上記にリンクされている私のブランド ガイドライン、ウェブサイト、またはソーシャル プラットフォームのアセット
      aiEnhanced: AIで強化された素材
      none: 提供した素材のみを使用
    utility:
      assistant: アシスタント
      notes: ノート
      summary: 概要
    STATIC: 静止画
    actionsSave: 保存して終了
    actionsSubmit: ブリーフを提出する。
    additionalDetails: 追加指示
    additionalNotes: その他のノート
    artDirectorLabel: アートディレクター
    artDirectorUpdated: アートディレクターが更新されました。
    assetNotes: 素材ノート
    assetsZipGeneratingTooltip: 素材zipを生成中です
    audio: 音声
    base: ベース
    baseCopyTranslationLabel: 'ベースコピー - {{language}}:'
    brandAssets: ブランド素材
    brandDescription: ブランド説明
    brandName: ブランド
    brandPersonality: ブランドパーソナリティ
    brandRequirements: 法的およびクリエイティブな要件
    briefSubmitted: ブリーフが提出され、これ以上の修正はできません。修正をご希望の場合はご担当者までご連絡ください。
    briefCsReviewAlertTitle: このブリーフは現在CSレビュー中であり、制作レビューに移行した後にのみ承認されます。
    briefCsReviewInformation: ブリーフを制作レビューに移動するには、ブリーフに移動して「制作レビューに提出」ボタンをクリックしてください。
    briefUgcAlertTitle: このブリーフにはUGC要件があり、現在{{state}}にあります。
    briefUgcInformation: UGC制作が完了してからでなければ、制作レビューに移動できません。
    campaignDetails: キャンペーンの詳細
    channels: チャンネル
    clientAndBrandDetails: クライアントおよびブランド詳細
    clientDescription: クライアント説明
    clientName: クライアント
    collapseAll: 全て折りたたむ
    disclaimer: 免責事項
    expandAll: 全て展開
    conceptIdea: コンセプトアイデア
    conceptBasics: 基本事項
    conceptVariation: 'コンセプトバリエーション {{ index }}'
    confirmOrderBtnLabel: ブリーフを承認する。
    confirmOrderCancelBtnLabel: キャンセル
    confirmOrderModalTitle: ブリーフを本当に承認しますか？
    confirmSubmitOrderModalInformation: '<0><1>送信</1>をクリックすると、ブリーフを編集できなくなります。</0>'
    confirmSubmitOrderModalTitle: よろしいですか？
    copyFilenameError: 'ファイル名のクリップボードへのコピーできませんでした'
    copyFilenameSuccess: 'ファイル名をクリップボードにコピーしました！'
    details: 詳細
    detailsLinkLabel: 詳細を表示
    dimension: サイズ（px)
    downloadAssets: 素材をダウンロード
    editLinkLabel: 編集
    editDetailsBtnLabel: 詳細を編集
    editNotesBtnLabel: ノートを編集
    editNotesClickOutside: テキストエリア外をクリックしてノートを保存
    editNotesPlaceholder: 編集ボタンをクリックしてこのエリアにノートを追加します。完了したら、テキストボックスの外をクリックしてノートを保存できます
    fileName: ファイル名
    group: グループ
    internalNotesOnly: インターナルのノート
    projectLevelQuestions: プロジェクトレベルの質問
    languageBaseLabel: '言語:'
    languageLabel: 翻訳が必要な言語を選択してください。
    languagesVariationInformation: 翻訳したコピーを後ほど要求いたします。
    languagesVariationInformationTitle: 翻訳バリエーション
    logo: ロゴ
    notesUpdated: ノートの更新
    orderDetails: 発注の詳細
    orderName: 'オーダー名：'
    projectDetailsSavedSuccess: 回答が保存されました
    projectDetails: プロジェクトの詳細
    projectNotes: プロジェクトノート
    orderNotificationInformation: 'このプロジェクトに関する全てのメール更新は、割り当てられたクライアントパートナーとクリエイティブスペシャリストと共に自動的に受信されます'
    orderNotificationTitle: このプロジェクトの準備ができたときに誰が通知を受け取るべきですか？
    platformSpecifics: プラットフォーム詳細
    productionBrief: 制作ブリーフ
    productionNotesPlaceholder: ' '
    productionTranslationLabel: 'プロダクト翻訳：'
    projectOverviewBtn: プロジェクトの概要
    region: 地域
    reviewYourDetails: 提出する前に内容をご確認ください。一度提出したら修正はできません。
    saveNotes: ノートを保存する
    messaging: メッセージ
    selectedAssets: 選択された素材
    submitBtn: 注文を送信する
    submittedDateLabel: '提出された日付：'
    delivery:
      deliveryDueDateLabel: '次の配信:'
      deliveryDueDateLinkLabel: 方法を学ぶ
      nextDeliveryTooltip: '<0>{{linkText}}</0> これは計算されます'
      changeDateLabel: 日付を変更
      adjustedDeliveryLabel: '調整された配信: '
      reasonLabel: 納期調整の理由
      reasonPlaceholderLabel: 理由を検索または入力します
      requiredLabel: 必須
      saveBtnLabel: 保存
      toast:
        success: 次の配信が調整されました
        saveError: 保存エラー
      reason:
        briefClarification: 説明の明確化が必要
        complexDeliverables: 複雑な納品物
        complexRevision: 複雑な修正
        storyboard: ストーリーボードが必要
        creativeRework: クリエイティブな再作成
        midProductionChange: 製作中の変更リクエスト
        expeditedProject: 迅速なプロジェクト
        splitDelivery: 分割配信
        workingFileTat: 作業ファイルのTAT
        specialFormat: 特別形式のカスタムタイムライン
        regionalHoliday: 地域の祝日（クライアント)
    summaryTitle: ブリーフ概要
    tableDetails: 詳細
    tableDimension: サイズ（px)
    tableLength: 最大長さ
    tablePlatform: プラットフォーム
    totalDeliverables: '全納品物: {{count}}'
    totalOrderDeliverables: 納品物の合計
    translation: '{{ language }} 翻訳'
    updateTranslationBtnLabel: 翻訳の更新
    updateTranslationSuccessMessage: 翻訳が更新されました
    updateTrelloCardBtnLabel: Trelloを更新する
    updateTrelloSuccessMessage: Trelloカードが更新されました。
    updatingTrelloBtnLabel: 更新中...
    urlFacebook: Facebook
    urlInstagram: Instagram
    urlOther: その他
    urlTwitter: Twitter
    urlWebsite: ウェブサイト
    urlYoutube: YouTube
    verticalName: 業界
    voiceOver: 'ボイスオーバー'
    websites: 'クライアントチャネル: '
  orderDeliverableList:
    adverts: コンセプト
    actionFilterBtnLabel: 'フィルター ({{totalFilters}})'
    Advertiser: 広告主
    alphaRevisionModalTitle: 修正を送信?
    alphaRevisionModalBody: クリエイティブが確認できる状態になりましたらメールにてお知らせいたします。 確認できる状態になるまでは、追加修正ができません。
    alphaRevisionModalBodyInternal: プロジェクトはデザイナーに返送され、クライアントへの納品が遅延されます。Trelloカードを「Revision Needed」に戻して下さい。
    csat:
      reasonQuality: クリエイティブの品質が期待に満たなかった
      reasonTurnaround: 納期が予想よりも遅かった
      reasonInstructions: ブリーフまたは修正指示が従われなかった
      reasonCommunication: CSMのサポートまたはコミュニケーションが不十分だった
      reasonPlatform: Shuttlerockプラットフォームに問題があった
      reasonOther: その他（詳細をご記入ください）
    quickFixDialog:
      title: '準備完了です'
      contentExpressDesign_one: 'お客様の{{count}}件の修正は、エクスプレスデザインサービスで<strong>4時間以内</strong>に完了します! <0>'
      contentExpressDesign_other: 'お客様の{{count}}件の修正は、エクスプレスデザインサービスで<strong>4時間以内</strong>に完了します! <0>'
      tooltipExpressDesign: 修正内容がエクスプレスデザインサービスに適用されない場合は、ご連絡のうえ、通常の納期が適用されます。
      contentReceiveEmail: クリエイティブをレビューできるようになりましたら、メールをお送りします。
      buttonCancel: キャンセル
      buttonSubmit: 修正を送信
    projectRatingReasonLabel: この回答を選んだ理由は何ですか？
    projectRatingReasonPlaceholder: オプションを選択してください
    projectRatingCommentLabel: すごい！何かお伝えしたいことはありますか？
    projectRatingCommentPlaceholder: 詳細を教えていただけますか？
    projectRatingDialogTitle: プロジェクトの承認おめでとうございます
    projectRatingDialogContentTitle: 'このプロジェクトにどの程度満足していますか? <0>'
    projectRatingDialogLowSatisfaction: まったく満足していない
    projectRatingDialogModerateSatisfaction: やや満足
    projectRatingDialogHighSatisfaction: '非常に満足'
    projectRatingDialogTooltip: ご意見はShuttlerockのサービス向上に役立てさせていただきます。
    projectRatingDialogValidation: 続行するにはオプションを選択してください
    projectRatingDialogCancel: キャンセル
    projectRatingDialogApprove: 校了
    Approve Creatives: 動画を承認
    approveProject: プロジェクトを承認
    approveProjectModalTitle: プロジェクトを承認?
    approveProjectModalBody: こちらの案件は完了いたしました。追加修正などはできません。 承認済みのプロジェクトはエクスポート・ダウンロードが可能です。
    Business account: ビジネスアカウント
    continueProductionBtn: 次のステップ
    continueProductionModalTitle: 次のステップ?
    continueProductionModalBody: こちらの案件を次のステップに進めます。次のステップの間は、追加修正はできません。 クリエイティブが確認できる状態になりましたらメールにてお知らせいたします。
    Download: ダウンロード
    downloadAll: 全てダウンロード
    downloadAsZip: zip形式でダウンロード
    exportMenu: エクスポート
    Modal: ポップアップ
    Order Now: 動画を注文
    Playdeck: プレイデック
    Select a business account: ビジネスアカウントを選択
    View Demo: デモ動画を見る
    View Playdeck: プレイデッキを見る
    accessRevoked: アクセスが取り消しされました。
    afterClickingApprove: <i>「動画を承認」</i>をクリックすると、修正が依頼出来なくになります。
    approveAndProceedBtn: パッケージ動画を作成
    automaticOrderApprovalText: 'この動画は{{ when }}に自動で承認されます。'
    chooseExistingFolder: 既存のフォルダーを選択する
    close: 閉じる
    conceptNameLabel: 'コンセプト {{conceptNumber}}:'
    confirmInternalDeliveryModalBtnText: クリエイティブを納品する
    confirmInternalDeliveryModalText: <i>クリエイティブを納品する</i> をクリックすると、クライアントに納品され、インターナルの修正を依頼することができなくなります。
    confirmInternalDeliveryModalTitle: よろしいですか
    confirmRequestInternalRevisionModalBtnText: インターナルの修正依頼
    confirmRequestInternalRevisionModalDirectiveText: 遅れが出ている場合は必ずご報告してください。
    confirmRequestInternalRevisionModalText: <i>インターナルの修正依頼</i> をクリックすると、修正コメントを追加するためのリンクにリダイレクトされます。コメント記載が完了次第、Trelloカードを <i>要修正</i> に移動することで修正が開始されます。
    confirmRequestInternalRevisionModalTitle: 内部修正処理
    continue: 続ける
    copyLink: リンクがクリップボードにコピーされました。
    copyVariationNumber: 'コピーバリエーション {{copyVariationNumber}}'
    createNewFolder: 新しいフォルダーを作成
    creativeFolder: クリエイティブフォルダー
    deliverableBadgeApproved: ヒーロー動画承認
    deliverableBadgeAwaiting: レビュー待ち
    deliverableBadgeRevision_one: '{{revisionNumber}}件の修正'
    deliverableBadgeRevision_other: '{{revisionNumber}}件の修正'
    dropboxExportComplete: Dropboxのエクスポートが完了しました。
    emailInstructions: メールでのご案内
    errorNoVideos: このオーダーには動画が含まれていない（静止画のみの）ため、YouTubeにエクスポートすることができません。
    exportCompleted: エクスポート完了
    exportCurrentlyCreatingDeliverablesText: ダウンロード用のzipファイルを作成中です。後ほど確認してください。
    exportError: 'エラー。 {{error}}。'
    exportProgress: '動画をエクスポート中 {{progress}}%'
    exportSpinnerText: '{{totalCount}} クリエイティブ中、 {{successCount}} クリエイティブをエクスポートしました。'
    formatNameSelectOptionsTitle: 納品フォーマット
    frameIOUrlBtn: frame.io に修正のコメントを追加する
    googleAdsAccount: Google広告アカウント
    hero: ヒーロー動画
    baseCopy: ベースコピー
    inProgressText: オーダーを製作中です。完了し次第、メールにてお知らせします。
    internalDeliveryButtonLabel: クリエイティブを納品する
    internalDeliveryModalTitle: クリエイティブを納品する
    internalDeliveryModalBody: プロジェクトはクライアントに納品され、インターナル修正が依頼できなくなります。クライアントの期待を管理するために、納品の遅れをちゃんと伝えてください。
    internalDeliveryRequestRevision: インターナルの修正を依頼する
    internalDeliveryRevisionInProgress: インターナルの修正が進行中です
    languageSelectOptionsTitle: 言語
    letsGoText: 開始する
    linkCopied: クリップボードにリンクがコピーされました。
    modalDeleteCancelButton: キャンセル
    mustBeLoggedInToApproveText: 動画を承認するにはログインが必要です。
    newFolderName: 新しいフォルダーの名前
    noMatchingCreatives: 条件に合う動画がありません。異なる絞り込み条件をお試しください。
    numHeroesRevised_one: '{{numRevisionRequests}} つのヒーロー動画に修正があります。'
    numHeroesRevised_other: '{{numRevisionRequests}}のヒーローのうち、{{numHeroes}}のヒーローに修正が依頼されます。'
    numHeroPendingReview_one: '{{numHeroPendingReview}} つのヒーロー動画がレビュー中です。'
    numHeroPendingReview_other: 'ヒーロー動画がレビュー中です {{numHeroPendingReview}}'
    orderApproveActionsText: この動画を承認すると、ダウンロードまたはFacebookや他のサービスにエクスポート出来ます。
    orderConfirmationText: パッケージ動画が完了したら、メールに通知が送信されます。
    orderNumber: ' #{{orderNumber}}'
    orderStateLabel: 'Status:  <1>{{orderState}}</1>'
    proceedToProduction: 次の処理に進める
    proceedToProductionDialogTitle: よろしいですか
    proceedToProductionDialogDescription: 一度承認されました動画は、次の処理に進み、納品されます。また、次の処理に進むと動画の修正依頼はできなくなります。
    requestChangesText: 。その他の修正があった場合、<1>アカウント管理者</1>に連絡してください。
    requestRevision: 修正を依頼
    removeFilterBtnLabel: 'フィルターを解除する ({{totalFilters}})'
    reviewBtnLabel: レビュー
    revisionCommentInfoText: 注意：修正作業が進んでいる可能性があります。コメントを追加した場合は、アカウントマネージャにご連絡ください。
    revisionConfirmationText: 動画は修正中です。修正が完了したら、メールに通知が送信されます。
    revisionRequestConfirmationBtn: 修正を依頼します。
    revisionRequestConfirmationText: ご指摘に関しましては、詳細に記載していただけますとデザインチーム側でより正確な修正が可能になりますので、ご協力お願いいたします。 もし、大きな修正が必要でしたら担当のクリエイティブスペシャリストに直接ご相談ください。
    revisionRequestConfirmationTitle: よろしいですか
    revisionRequestFrameIoBtn: Frame.io
    revisionRequestFrameIoLink: Frame.ioを利用するのは初めてですか？こちらが使い方です。
    revisionRequestHeading: 修正を依頼する
    revisionRequestStep1Description: 下記の <strong>Frame.io</strong> リンクをクリックして、クリエイティブをご覧ください。
    revisionRequestStep1Label: Step1 Frame.ioを開く
    revisionRequestStep2Description: 修正をしたい箇所にコメントと、場所を描いて示してください。
    revisionRequestStep2Label: Step2 フィードバックを送る
    revisionRequestStep3Description: 完了したら、このページに戻り <strong>修正を登録する</strong> をクリックしてください。
    revisionRequestStep3Label: Step3 修正を登録する
    revisionRequestSubHeading: こちらで当選キャンペーンの用意が完了する前に、全てを確実に確認してください。
    revisionRequestSubmitRevision: 修正を登録する
    revisionSubmitConfirmationModalBtn: 修正を登録する
    revisionSubmitConfirmationModalText: <strong><i>修正を登録する </i></strong> をクリックすると、シャトルロックに通知され、修正を開始します。Frame.ioへのコメントや編集ができなくなります。
    revisionSubmitConfirmationModalTitle: よろしいですか。
    revokeAccessToMyYoutubeAccount: アカウントへのアクセスを取り消す
    resultFilters: '検索結果 ({{numOfResults}})'
    seconds: 秒
    selectAnAdvertiser: 広告主を選択する
    selectFolder: フォルダーを選択
    sendExportInstructionsToSomeoneElse: 他のユーザーにエクスポートの手順を送る
    sendInstructionsToSomeoneElse: 他のユーザーに手順を送る
    sentToProduction_one: '{{numRevisionRequests}} 納品物を制作に送ります。'
    sentToProduction_other: '{{numRevisionRequests}} 納品物を制作に送ります。'
    shareUrlButtonText: シェア
    sortAndFilterMenuTitle: 絞り込み
    submitRevisions: 修正を送信
    unitNumber: 'ユニット {{unitNumber}}'
    viewBtnLabel: 表示
    viewBriefSummary: プロジェクトブリーフ
    wouldYouLike: このリンクをEメールで共有しますか
    youDontHaveGoogleAdsAccount: Google広告アカウントをお持ちではありません
    youHaveWithCount_one: '{{maxNumRevisions}}回中残り{{revisionLeft}}回の修正が依頼出来ます'
    youHaveWithCount_other: '{{maxNumRevisions}}回中残り{{revisionLeft}}回の修正が依頼出来ます'
    youtubeMenuModalHeading: クリエイティブをどのようにエクスポートしますか
  orderDeliverableUpload:
    activeAdmin: 'Active Admin: '
    cannotAddDeliverableErrorDesc: このオーダーの納品物をアップロードすることができません。
    cannotAddDeliverableErrorTitle: 'このページにはアクセスできません:'
    conceptOptionLabel: 'コンセプト {{number}} - {{name}}'
    conceptHeaderLabel: 'コンセプト'
    confirmDelete: 削除する
    confirmDeleteText: 納品物を削除してよろしいですか。
    confirmDeleteTitle: 納品物を破棄しますか。
    containsAiHeaderLabel: AIを含む
    containsAiHeaderTooltip: このコンセプトで使用されている素材 (画像、音声、動画、音楽) が主に AI モデル サービス プロバイダー (Midjourney、Luma AI、ElevenLabs、Sora など) を使用して生成されたか、大幅に編集された場合 (背景生成、製品の配置など) は、[はい] を選択します。
    currentState: '現ステージ:'
    currentWorkflowStep: '現在のワークフローステップ:'
    deletePermissionError: 申し訳ありませんが、この納品物をアーカイブする権限がありません。
    deliverableFormatHeaderLabel: フォーマット
    deliverableExportNameHeaderLabel: エクスポートファイル名
    deliverableFormat: 納品フォーマット
    deliverableFormatErrorRequired: この納品物の有効なフォーマットを入力してください。
    deliverableName: 納品物名
    deliverableNameHeaderLabel: 納品物名
    deliverables: 納品物
    deliveryPageLink: 納品ページのリンク：
    duplicateFileFoundDialogTitleDeprecated: '重複ファイルが見つかりました'
    duplicateFileFoundDialogContentDeprecated: 'アップロードされるファイルはこちらのプロジェクトにアップロードされた「{{fileName}}」ファイルと同じ属性を持っています。このファイルをアップロードされるファイルと差し替えますか。'
    duplicateFileFoundDialogActionReplaceDeprecated: 'ファイルを差し替え'
    duplicateFileFoundDialogActionCancelDeprecated: 'アップロードをキャンセル'
    duplicateFileFoundDialogTitle: 重複ファイル
    duplicateFileFoundDialogContent: 同一の属性を持つファイルが複数検出されました。
    duplicateFileFoundDialogNew: 新規
    duplicateFileFoundDialogExisting: 既存
    duplicateFileFoundDialogActionContinue: 続ける
    duplicateFileFoundDialogActionProceed: 続行
    duplicateFileFoundDialogActionCancel: キャンセル
    duplicateFileFoundDialogOptionUploadNewVersionTitle: 新しいファイルを新しいバージョンとしてアップロード
    duplicateFileFoundDialogOptionUploadNewVersionDescription: 新しいファイルは既存ファイルに対する新しいバージョンとして積み重ねられます。
    duplicateFileFoundDialogOptionKeepOriginalTitle: 既存を保持して新規を破棄
    duplicateFileFoundDialogOptionKeepOriginalDescription: 変更はありません。新しいファイルは破棄されます。
    duplicateFileFoundDialogOptionKeepBothTitle: 両方保持
    duplicateFileFoundDialogOptionKeepBothDescription: 両方のファイルを保持します。新しいファイルに「Unit」番号が追加されます。
    durationHeaderLabel: 再生時間
    bitrate: '{{bitrate}}kbps'
    fps: '{{fps}}fps'
    fileTypeHeaderLabel: ファイルタイプ
    heightHeaderLabel: 縦幅
    heroLabel: 'ヒーロー {{position}}'
    heroHeaderLabel: ヒーロー動画
    failedUpload: アップロード失敗
    failedUploadUnsupported: アップロード失敗 - 未対応のファイル形式です。
    languageHeaderLabel: 翻訳が必要な言語を選択してください。
    localeHeaderLabel: ロケール
    loading: ロード中
    lockedTooltip: 承認済み
    measurementUnitHeaderLabel: 測定単位
    audioUrlHeaderLabel: 音声 URL
    amplifyLinkHeaderLabel: Amplify Link
    newAssetLabel: このプロジェクトにファイルをアップロードしてください。
    newAssetHelperText: ファイルをドロップするか参照して追加してください。対応する納品物に自動的にマッチさせます。保存前に手動で調整できます。
    nextWorkflowStep: '次のワークフローステップ:'
    platformHeaderLabel: プラットフォーム
    revisionHeaderLabel: 修正
    workingFiles:
      title: 作業ファイル
      uploadedCount: '{{count}}件のアップロードに成功しました。'
      downloadAll: 全てダウンロード
      helperText: 'オプション: 受信者が独自の編集を行う場合は、編集可能またはレイヤー化されたファイル（PSD、AEなど）をアップロードしてください。'
      columnHeadings:
        filename: 名前
        uploader: アップロード者
        uploadedAt: アップロード日
        size: サイズ
      empty: ファイルなし
    footerHelperText: 保存すると、ファイルは［レビュー］タブに表示され、承認の準備が整います。
    originalCreativeOptionLabel: オリジナルクリエイティブ
    saveButton: 保存
    saveOrderBtn: プロジェクトを保存
    saved: オーダーが保存されました。
    state: 状態
    title: 納品物をアップロード
    titleErrorRequired: この項目は必須項目です。
    unitHeaderLabel: ユニット
    uploadErrorText: ' {{uploadErrorCount}} 必須のメタ情報がありません'
    uploadAudioUrlInvalidText: ' {{audioUrlInvalidCount}} 無効なオーディオ URL'
    uploadDeliverableFileNameInvalid_one: ' {{count}}個の納品物ファイル名にサポートされていない文字が含まれています。'
    uploadDeliverableFileNameInvalid_other: ' {{count}}個の納品物ファイル名にサポートされていない文字が含まれています。'
    uploadDeliverableFileExtensionInvalid_one: ' {{count}}個の納品物ファイル名の拡張子が元のものと一致しません。'
    uploadDeliverableFileExtensionInvalid_other: ' {{count}}個の納品物ファイル名の拡張子が元のものと一致しません。'
    uploadHeroMissingText: ' コンセプト {{heroMissingConcepts}} の動画情報を指定してください'
    uploadSuccessText: ' {{uploadSuccessCount}} アップロードに成功しました'
    variantHeaderLabel: バリアント
    versionHeaderLabel: バージョン
    widthHeaderLabel: 横幅
    yes: はい
    utility:
      assistant: アシスタント
      overview: 概要
      summary: 概要
    containsAIOptions:
      YES: はい、AIが含まれています
      NO: いいえ
      UNSURE: よくわかりません
    audioTypeNoAudio: 背景音楽なし
    audioTypeClientProvided: クライアント提供の音声
    amplifyLink:
      linkTemplate: リンクテンプレート
      conceptName: 'コンセプト {{position}} - {{name}}'
      reload: リロード
      viewInAmplify: Amplifyで表示
      replace: 置換
      matchedCompCount: '{{count}}個のコンプがフォーマットと一致しました'
      matchingCompNotFound: 一致するコンプが見つかりません
      renderingDeliverables: '納品物をレンダリング中 ({{renderedCount}}/{{totalCount}} 完了)...'
      linkATemplate: テンプレートをリンク
      amplifyTemplateID: Amplify テンプレート ID
      amplifyTemplateIDRequired: Amplify テンプレート IDは必須です
      amplifyTemplateLinkSuccessMsg: Amplifyからの納品物の取得を開始しました。これには時間がかかる場合があります。ページを更新して進捗を確認してください。
    amplifyTemplateImport:
      importFromAmplifyTemplate: Amplifyテンプレートからインポート
      import: インポート
      revisions: リビジョン
      revision: リビジョン {{versionNumber}}
      compositions: コンポジション
      compositionsRequired: コンポジションを1つ以上選択してください
      templateName: '名前: {{name}} ({{id}})'
      templateNotFound: テンプレートが見つかりません
      amplifyTemplateID: Amplify テンプレート ID
      amplifyTemplateIDRequired: Amplify テンプレート IDは必須です
      templateImportSuccessMsg: テンプレートのコンポジションが正常にインポートされました。
      next: 次へ
      back: 戻る
      finish: 完了
    newVariantOption: '+ 新しいバリアント'
    createVariantDialog:
      title: 新しいバリアントを作成
      titleWithConcept: '新しいバリアントを作成 — {{conceptName}}'
      sequenceLabel: バリアント番号
      sequenceRequired: バリアント番号は必須です
      sequenceInvalid: 整数を入力してください
      sequenceMin: 0以上の数値を入力してください
      sequenceDuplicate: このバリアント番号は既に存在します
      nameLabel: 名前
      nameRequired: 名前は必須です
      namePlaceholder: バリアント名を入力
      createButton: 作成
    batchNameVariantsDialog:
      title: 新しいバリアントに名前を付ける
      variantLabel: 'バリアント {{sequence}}'
      nameRequired: 名前は必須です
      placeholder: バリアント名を入力
      saveButton: 保存
  orderList:
    actionFilterBtnLabel: 'フィルター ({{totalFilters}})'
    brandsSelectOptionsTitle: ブランド
    clientPartnersSelectOptionsTitle: クライアントパートナー
    clientsSelectOptionsTitle: クライアント
    creativeSpecialistsSelectOptionsTitle: クリエイティブスペシャリスト
    groupsSelectOptionsTitle: グループ
    regionsSelectOptionsTitle: 地域
    removeFilterBtnLabel: 'フィルターを解除する ({{totalFilters}})'
    resultFilters: '検索結果 ({{numOfResults}})'
    salesTerritorySelectOptionsTitle: 営業地域
    searchPlaceholder: 検索
    sortAndFilterMenuTitle: フィルター
    statusGroupTitle: ステータス
    statusPlaceholder: 全てのステージ
    title: プロジェクトトラッカー
  orderListTable:
    actions: アクション
    actionsAdjustRevisions: 修正回数を増やす
    actionsBtnAriaLabel: 受注アクションメニューを開く
    actionsConfirmOrder: ブリーフを承認する
    actionsContinueOrder: 注文を進める
    actionsDelete: 削除
    actionsReorder: 再注文
    actionsReviewCreatives: 納品物を確認する
    actionsViewCreatives: 納品物を見る
    addDeliverablesLabel: 納品物を追加する
    brand: ブランド
    briefSummaryLabel: ブリーフの概要
    cancelBtn: キャンセル
    client: クライアント
    customOrderLabel: カスタムオーダー
    emptyTableMessage: 注文はありません。「新規受注」を選択し、新しく受注願います。
    maxNumRevisionsLabel: 修正の最大回数
    maxNumRevisionsPlaceholder: 修正の回数を設定する
    modalAdjustRevisionsTitle: '{{workflowStep}}ステップの修正回数を設定する '
    modalConfirmOrderTitle: このブリーフを承認してよろしいですか。
    modalDeleteCancelButton: キャンセル
    modalDeleteConfirmationButton: 受注を削除
    modalDeleteConfirmationText: 下書きは削除されます。復元はできませんので、ご了承の上お進みください。
    modalDeleteConfirmationTitle: 本当に大丈夫ですか?
    orderName: 受注 Name
    orderNumber: 'オーダー番号： {{serialId}}'
    productionBriefLabel: 制作ブリーフ
    status: ステージ
    submitBtn: 修正回数を増やす
    successDeleteContent: オーダーが削除されました。
    successDeleteHeader: 削除された下書き
  orderState:
    cs_review: CS確認中
    ugc_ideation: UGCアイデア
    asset_production: アセット制作
  orderSummary:
    Back: 戻る
    Edit: 編集
    Update: 更新する
    cancelBtn: キャンセル
    orderNotificationTitle: 納品物が完了した際に通知を受け取る方をお知らせください。
    submitBtn: 注文を提出
  orderingSidebar:
    brandAssetsTitle: ブランド素材
    campaignDetailsTitle: キャンペーンの詳細
    conceptVariations_one: '{{count}} つのコンセプトバリエーション'
    conceptVariations_other: '{{count}} つのコンセプトバリエーション'
    reviewMyOrder: オーダーを確認する
    title: 概要
    tooltipMessage: 回答されていない必須項目があります。
    translationVariations_one: '{{count}} つの翻訳バリエーション'
    translationVariations_other: '{{count}} つの翻訳バリエーション'
  passwordStrength:
    Password Strength: パスワードの強度
  previewBox:
    audio: 音声
    brand: ブランド
    compressed: Zip
    caption: プレビューエリア
    font: フォント
    logo: ロゴ
    music: 音楽
    stills: 画像
    video: 動画
  priceList:
    title: 価格
  productCategory:
    blank_category: '---'
    image_to_video: 画像から動画へ
    multi_channel_videos: マルチチャンネル動画
    multiple_images_to_video: 複数の画像から動画へ
    tvc_to_video: TVCから動画へ
    up_to_15_second_videos: 最大15秒の動画
    up_to_30_second_videos: 最大30秒の動画
    up_to_6_second_videos: 最大6秒の動画
    video_and_images: ビデオと画像
    video_only: ビデオのみ
  questionForm:
    questionErrorRequired: これは必須の質問です
  salesTerritories:
    ANZ: オーストラリアとニュージーランド
    ASIA: アジア・太平洋
    DELTA: DELTA
    EMEA: ヨーロッパ・中東・アフリカ
    JAPAN: 日本
    NAM: 北米
    UKI: 英国とアイルランド
    VIDMOB: VidMob
  setPassword:
    description: アカウントの新しいパスワードを入力してください：
    passwordErrorRequired: パスワードは必須です。
    passwordLabel: パスワード
    passwordLengthMessage: パスワードは12文字に設定してください。
    passwordPlaceholder: 新しいパスワードを入力する
    resetPasswordBtn: パスワードをリセットする
    signUpBtn: 登録する
    title: パスワードを設定する
    expiredTitle: パスワード再設定期限が切れました。
    expiredDescription: 新しいパスワード再設定リンクを申請してください。
    expiredWarningTitle: このリンクは無効になっています。
    expiredWarningContent: パスワード再設定リンクの期限が切れるかすでに使用されました。メールにもう一度リンクを送信してください。
    resubmitBtn: メール再送
  signUpForm:
    back: 戻る
    emailErrorEmail: Eメールアドレスを入力してください。
    emailErrorRequired: この項目は必須項目です。
    emailLabel: Eメールアドレス
    emailPlaceholder: ' '
    firstNameErrorRequired: この項目は必須項目です。
    firstNameLabel: 名前
    firstNamePlaceholder: 名
    heading: 登録する
    lastNameErrorRequired: この項目は必須項目です。
    lastNameLabel: 姓
    lastNamePlaceholder: 姓
    passwordErrorRequired: この項目は必須項目です。
    passwordLabel: パスワード
    passwordPlaceholder: ' '
    passwordLengthMessage: パスワードは12文字に設定してください。
    rememberMeLabel: ログイン情報を保存する。
    signUpBtn: 登録する
    signUpConfirmationText: '{{email}} にEメールが送信されました。'
    signUpConfirmationTitle: 登録ありがとうございます。
  signUpGettingStarted:
    alreadyHaveAccount: アカウントをお持ちですか？
    continueWithEmail: Eメールで続ける
    continueWithFacebook: Facebookで続ける
    continueWithGoogle: Googleで続ける
    heading: 始める
    signIn: サインイン
  submissionStateErrorModal:
    campaignDetails: キャンペーン詳細
    description: 提出の準備ができましたら、ブリーフにお戻りください。
    missingInformation: '必要事項が次のページから抜けています:'
    return: ブリーフの概要に戻る。
    title: ブリーフの必要項目が全て記入されていません。
  toast:
    saveAndExitOrderBriefDescription: ブリーフが正常に保存されました。戻ってきたときにお待ちしています。
    saveAndExitOrderBriefTitle: ブリーフが保存されました！
  translatable:
    inputPlaceholder: 答えを記入してください...
  unconfirmedEmail:
    body: アカウントの確認のためにメールをお送りいたしましたので、メールを開きリンクをクリックしてください。メールが届いていませんか？<1>Resend Confirmation</1>
    heading: メールアドレスが確認できません。
  uploadElement:
    uploaderErrorMessage: アップローダーを表示する際にエラーが発生しました。ご担当者にご連絡ください。
  uploader:
    file: ファイル
    fileLimitHitWithCount_one: 'アップロードできるのは{{count}} ファイルまでです。'
    fileLimitHitWithCount_other: 'アップロードできるのは{{count}} ファイルまでです。'
    file_other: ファイル
    noMoreFilesMessage: これ以上ファイルをアップロードできません
    uploaderText: 'ここに {{files}} をドロップするか、こちらをクリックするとファイルブラウザーが開きます {{browse}}。'
  userInvite:
    cancelBtn: キャンセル
    copyInviteLink: 招待リンクをコピー
    emailErrorRequired: メールアドレスは必須です。
    emailLabel: Eメール
    emailPlaceholder: joe@example.com
    firstNameLabel: 名
    firstNamePlaceholder: 太郎
    lastNameLabel: 性
    lastNamePlaceholder: 山田
    modalContent: 'ユーザーをShuttlerock Cloudに招待する自動メールを送信するか、招待リンクをコピーしてください。'
    modalHeader: ユーザーを招待
    sendInviteEmail: 招待メールを送信
    submitBtn: 招待用のEメールを送信する
    userCreatedWithEmail: ユーザーアカウントが作成され、Shuttlerock Cloud招待メールが送信されました
    userCreatedWithoutEmail: ユーザーが作成され、Shuttlerock Cloud招待リンクがクリップボードにコピーされました
  userList:
    actions: アクション
    actionsBtnAriaLabel: ユーザーアクションメニューを開く
    actionsCopyInviteLink: 招待リンクをコピー
    actionsResendInvite: 招待を再送信
    actionsSendInvite: 招待を送信
    copyInviteLinkSuccess: Shuttlerock Cloud招待リンクがクリップボードにコピーされました
    email: メールアドレス
    emptyTableMessage: 表示できるユーザーがありません。「新規ユーザー」を選択してください。
    invitationStatus: 招待のステータス
    inviteAccepted: '{{at}} に招待が承諾されました。'
    inviteCreated: '{{at}} に招待が作成されました。'
    inviteSent: '{{at}} に招待が送信されました。'
    newUser: 新規ユーザー
    notInvited: 招待されていません。
    resendInviteSuccessMessage: '招待が{{email}}に再送されました。'
    sendInviteSuccessMessage: '招待メールが{{email}}に送信されました。'
    userName: ユーザー名
  verticals:
    Agency - Global: エージェンシー - グローバル
    Agency - Independent: エージェンシー - インディペンデント
    App Install: アプリインストール
    Automotive: 自動車
    Beverages: 飲料
    Charities & Organisations: 非営利団体(チャリティ)
    Consumer Goods: 小売
    Cosmetics & Luxury: 化粧品・ラグジュアリー
    CPG: CPG
    Disruptors: ディスラプター
    ECom: Eコマース
    eCommerce: Eコマース
    Education: 教育
    Energy & Utilities: エネルギー・公益事業
    Entertainment: エンターテイメント
    Entertainment & Media: エンターテイメント
    Financial Services: 金融
    FinServ: 金融サービス
    FinTech: フィンテック
    Food and Beverage: 飲食
    Gaming: ゲーム
    Government & Politics: 政府・政治
    Health & Fitness: 健康・フィットネス
    Health & Pharmaceuticals: ヘルスケア
    Healthcare: ヘルスケア
    Organization & Associations: 組織・協会
    Other: その他
    Professional Services: プロフェッショナルサービス
    Restaurants: 飲食
    Retail: 小売
    Services: サービス
    Social Commerce: ソーシャルコマース
    Sports & Fitness: スポーツ・フィットネス
    Technology: テクノロジー
    Tech & Telecommunications: IT & 情報処理
    Telecommunications: 通信
    Travel: 旅行
    Travel & Leisure: 旅行・レジャー
